module.exports = __webpack_public_path__ + "static/img/icon_bids_num.939a378c.png";